<div class="top">
    <h5 class=" fw-bold">{{isInPreviewMode ? (dialogData?.lgaDetails?.department || '') + ' LGA Settings' : 'Add New LGA Settings'}}</h5>
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"
        (click)="close()">
        <g clip-path="url(#clip0_3558_32756)">
            <path
                d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345"
                stroke="#F00000" stroke-width="2.16781" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_3558_32756">
                <rect width="17.3425" height="17.3425" fill="white" transform="translate(0.806641 0.748047)" />
            </clipPath>
        </defs>
    </svg>
</div>

<div class="form-wrapper">
 

    <div class="bg-white p-4 m-0 row g-4">
        <div class=" col-4 col-lg-3 m-0">
            <input type="file" #logoUploadInput accept="image/*" hidden="true" (change)="onLogoChange($event)">
            <div class="image" (click)="triggerUploadLogo()">
                <div class="image-placeholder"  *ngIf="!logoUploadControl?.value">
                    <svg width="33" height="29" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.2"
                            d="M29.735 4.11181H24.8606L22.4438 0.485786C22.3843 0.396597 22.3038 0.32344 22.2093 0.272778C22.1148 0.222117 22.0093 0.195511 21.9021 0.195312H11.4581C11.3508 0.195511 11.2453 0.222117 11.1508 0.272778C11.0563 0.32344 10.9758 0.396597 10.9163 0.485786L8.49621 4.11181H3.62507C2.75947 4.11181 1.92933 4.45567 1.31726 5.06774C0.705186 5.67981 0.361328 6.50995 0.361328 7.37555V25.6525C0.361328 26.5181 0.705186 27.3483 1.31726 27.9603C1.92933 28.5724 2.75947 28.9163 3.62507 28.9163H29.735C30.6006 28.9163 31.4308 28.5724 32.0429 27.9603C32.6549 27.3483 32.9988 26.5181 32.9988 25.6525V7.37555C32.9988 6.50995 32.6549 5.67981 32.0429 5.06774C31.4308 4.45567 30.6006 4.11181 29.735 4.11181ZM31.6933 25.6525C31.6933 26.1719 31.487 26.67 31.1197 27.0372C30.7525 27.4045 30.2544 27.6108 29.735 27.6108H3.62507C3.10571 27.6108 2.60763 27.4045 2.24038 27.0372C1.87314 26.67 1.66683 26.1719 1.66683 25.6525V7.37555C1.66683 6.85619 1.87314 6.35811 2.24038 5.99086C2.60763 5.62362 3.10571 5.41731 3.62507 5.41731H8.84707C8.95456 5.41738 9.06041 5.3909 9.15521 5.34022C9.25001 5.28955 9.33082 5.21625 9.39048 5.12683L11.8057 1.50081H21.5512L23.9696 5.12683C24.0293 5.21625 24.1101 5.28955 24.2049 5.34022C24.2997 5.3909 24.4056 5.41738 24.513 5.41731H29.735C30.2544 5.41731 30.7525 5.62362 31.1197 5.99086C31.487 6.35811 31.6933 6.85619 31.6933 7.37555V25.6525ZM16.6801 9.3338C15.389 9.3338 14.127 9.71663 13.0536 10.4339C11.9801 11.1511 11.1435 12.1706 10.6494 13.3633C10.1554 14.5561 10.0261 15.8685 10.278 17.1347C10.5299 18.401 11.1515 19.564 12.0644 20.4769C12.9773 21.3898 14.1404 22.0115 15.4066 22.2634C16.6728 22.5152 17.9853 22.386 19.178 21.8919C20.3708 21.3979 21.3902 20.5612 22.1075 19.4878C22.8247 18.4143 23.2076 17.1523 23.2076 15.8613C23.2076 14.1301 22.5198 12.4698 21.2957 11.2457C20.0715 10.0215 18.4113 9.3338 16.6801 9.3338ZM16.6801 21.0833C15.6472 21.0833 14.6376 20.777 13.7789 20.2032C12.9201 19.6294 12.2508 18.8139 11.8556 17.8597C11.4603 16.9055 11.3569 15.8555 11.5584 14.8425C11.7599 13.8296 12.2572 12.8991 12.9876 12.1688C13.7179 11.4385 14.6483 10.9411 15.6613 10.7396C16.6743 10.5381 17.7242 10.6416 18.6784 11.0368C19.6326 11.432 20.4482 12.1014 21.022 12.9601C21.5958 13.8189 21.9021 14.8285 21.9021 15.8613C21.9021 17.2463 21.3519 18.5745 20.3726 19.5538C19.3932 20.5331 18.065 21.0833 16.6801 21.0833Z"
                            fill="black" />
                    </svg>
                    <span class="text-decoration-underline">UPLOAD LOGO</span>
                </div>

                <div class="uploaded-image" [ngClass]="{'disabled': isInPreviewMode}"  *ngIf="logoUploadControl?.value">
                    <img [src]="logoUploadControl?.value?.readableUrl" alt="image_upload" (click)="triggerUploadLogo()">
                    <span class="replace-image-btn">REPLACE IMAGE</span>
                </div>

            </div>
            <app-error-message [form]="form" controlName="logo" [showErrorMessage]="showErrorMessages || showLogoErrorMessage"
                label="Logo"></app-error-message>
        </div>
        <div class="col-lg-9 m-0 px-3">
            <form [formGroup]="form" (ngSubmit)="search()" *ngIf="form">
                <div class="row g-3">

                    <div class="field col-md-6 ">
                        <label>LGA</label>
                        <ng-select bindLabel="name" bindValue="id" [items]="lgaList"
                            placeholder="-- Select LGA --" formControlName="lga"></ng-select>

        
                        <app-error-message [form]="form" [controlName]="'lga'" [label]="'LGA'"
                            [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div>

                    <div class="field   col-md-6">
                        <label>Acronym</label>
                        <input type="text" class="form-control tax-input" formControlName='acronym' [maxlength]="20" id=""
                            placeholder="ENTER ACRONYM">
                        <app-error-message [form]="form" controlName="acronym" label="Acronym"
                            [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div>


                    <div class="field  col-12">
                        <label>DESCRIPTION</label>
                        <textarea class="form-control tax-textarea" style="height: 70px !important;"
                            formControlName='description' id="" placeholder="ENTER DESCRIPTION" [maxlength]="200"> </textarea>
                        <app-error-message [form]="form" controlName="description"
                            [showErrorMessage]="showErrorMessages" label="Description"></app-error-message>
                    </div>


                    <div class="field  col-12">
                        <label>OFFICE ADDRESS</label>
                        <textarea class="form-control tax-textarea" style="height: 70px !important;"
                            formControlName='address' id="" placeholder="ENTER LGA OFFICE ADDRESS" [maxlength]="200"> </textarea>
                        <app-error-message [form]="form" controlName="address"
                            [showErrorMessage]="showErrorMessages" label="Lga office address"></app-error-message>
                    </div>

               

                    <div class="col-lg-6">
                        <div class="color-input-section ">
                            <span class="">Primary Color</span>
                            <div class="row g-2 color-input-row">
                                <div class="field col-6">
                                    <label>BG Color</label>
                                    <input type="color" formControlName="primaryBackgroundColor" class="color-input">
                                    <app-error-message [form]="form" controlName="primaryBackgroundColor"
                                        [showErrorMessage]="showErrorMessages"
                                        label="Primary background color"></app-error-message>
                                </div>

                                <div class="field col-6">
                                    <label>Text Color</label>
                                    <input type="color" formControlName="primaryTextColor" class="color-input">
                                    <app-error-message [form]="form" controlName="primaryTextColor"
                                        [showErrorMessage]="showErrorMessages"
                                        label="Primary text color"></app-error-message>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="color-input-section ">
                            <span class="">Secondary Color</span>
                            <div class="row g-2 color-input-row">
                                <div class="field col-6">
                                    <label>BG Color</label>
                                    <input type="color" formControlName="secondaryBackgroundColor" class="color-input">
                                    <app-error-message [form]="form" controlName="secondaryBackgroundColor"
                                        [showErrorMessage]="showErrorMessages"
                                        label="Secondary background color"></app-error-message>
                                </div>

                                <div class="field col-6">
                                    <label>Text Color</label>
                                    <input type="color" formControlName="secondaryTextColor" class="color-input">
                                    <app-error-message [form]="form" controlName="secondaryTextColor"
                                        [showErrorMessage]="showErrorMessages"
                                        label="Secondary text color"></app-error-message>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field col-md-6 ">
                        <label>Head Title</label>
                        <input type="text" class="form-control tax-input" formControlName='headTitle' [maxlength]="50" id=""
                            placeholder="ENTER HEAD TITLE">
                        <app-error-message [form]="form" controlName="headTitle" [showErrorMessage]="showErrorMessages"
                            label="LGA head's title"></app-error-message>
                    </div>

                    <div class="field col-md-6 ">
                        <label>Head Name</label>
                        <input type="text" class="form-control tax-input" formControlName='headName' id=""
                            placeholder="ENTER HEAD NAME" [maxlength]="50">
                        <app-error-message [form]="form" controlName="headName" [showErrorMessage]="showErrorMessages"
                            label="LGA head's name"></app-error-message>
                    </div>

                    <div class="field col-md-6">
                        <label>Head Signature</label>

                        <app-upload-input [accept]="'.png, .jpg, .jpeg, .pdf'" [maxFileSize]="1" [isInPreviewMode]="false"
                        (fileChange)="onFileChange($event, 'headSignature')"
                        (error)="onError($event, 'headSignature')" [form]="form"
                        controlName="headSignature"></app-upload-input>

                        <app-error-message [form]="form" controlName="headSignature" label="Commissioner's signature"
                            
                            [showErrorMessage]="showErrorMessages ||  showSignatureErrorMessage"></app-error-message>
                        <small class="ms-auto" style="font-size: 12px;">1MB Maximum (.png, .jpg, .jpeg, .pdf)</small>

                    </div>

                    <div class="field col-md-6">
                        <label>Background Image</label>

                        <app-upload-input [accept]="'.png, .jpg, .jpeg, .pdf'" [maxFileSize]="1" [isInPreviewMode]="false"
                        (fileChange)="onFileChange($event, 'lgaBg')"
                        (error)="onError($event, 'lgaBg')" [form]="form"
                        controlName="lgaBg"></app-upload-input>

                        <app-error-message [form]="form" controlName="lgaBg" label="Background image"
                            
                            [showErrorMessage]="showErrorMessages ||  showSignatureErrorMessage"></app-error-message>
                        <small class="ms-auto" style="font-size: 12px;">1MB Maximum (.png, .jpg, .jpeg, .pdf)</small>
                    </div>


                    <div class="col-md-12" *ngIf="!isInPreviewMode">
                        <button [disabled]="isSubmitting" type="submit" class="btn flex-btn mt-4 rounded-1 custom-btn-primary w-100"
                            (click)="submit()">
                            {{ isSubmitting ? 'SAVING...' : 'SAVE' }}
                        </button>
                    </div>

                    <div class="col-md-12 d-flex" *ngIf="isInPreviewMode">
                        @if(isEditingAllowed){
                            <button [disabled]="isSubmitting || form.pristine" type="submit" class="btn flex-btn mt-4 rounded-1 custom-btn-primary w-100"
                            (click)="edit()">
                            {{ isSubmitting ? 'Saving Changes...' : 'Save Changes' }}
                        </button>
                    }
                        @else {
                            <a role="button" class="ms-auto d-flex align-items-center" style="text-decoration: none; gap: 2px; cursor: pointer; :hover {
                                color: blue; 
                            }" (click)="allowEditing()"><small class="material-icons" style="font-size: 18px;">edit</small> Edit</a>
                        }

                        
                    </div>
                </div>
            </form>
        </div>

    </div>





</div>